// Focus for labels
function jobFocusLabels($) {

  $('.wpcf7-form input').focus(function() {
    $(this).parent().parent('label').addClass('has-focus');
  }).blur(function() {
    $(this).parent().parent('label').removeClass('has-focus');   
  });

}

export default jobFocusLabels